export const envConfig = process.env;